import * as tslib_1 from "tslib";
import getToCcRecipients from './getToCcRecipients';
import buildReplyForwardMessageBody from '../utils/buildReplyForwardMessageBody';
import createItemIdForRequest from '../utils/createItemIdForRequest';
import getDefaultBodyType from '../utils/getDefaultBodyType';
import { loadAllRecipientsForItem } from 'owa-mail-store-actions';
import createItem from 'owa-mail-store/lib/services/createItem';
import createResponseFromModernGroup from 'owa-mail-store/lib/services/createResponseFromModernGroupItem';
import store from 'owa-mail-store/lib/store/Store';
import bodyContentType from 'owa-service/lib/factory/bodyContentType';
import replyAllToItem from 'owa-service/lib/factory/replyAllToItem';
import replyToItem from 'owa-service/lib/factory/replyToItem';
import getDocumentId from '../utils/getDocumentId';
import getReplyForwardSubject from './getReplyForwardSubject';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { select } from 'satcheljs/lib/legacy';
// create a draft reply in a single call
export default select({
    items: function () { return store.items; },
})(function createReply(referenceItemId, isReplyAll, useGroupAction, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var referenceItem, replyItem, message;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!state.items.has(referenceItemId)) {
                        return [2 /*return*/, null];
                    }
                    referenceItem = state.items.get(referenceItemId);
                    return [4 /*yield*/, createReplyItem(referenceItem, isReplyAll)];
                case 1:
                    replyItem = _a.sent();
                    return [4 /*yield*/, createReplyFromReplyItem(replyItem, useGroupAction)];
                case 2:
                    message = _a.sent();
                    return [2 /*return*/, message];
            }
        });
    });
});
// alternatively create an instance of a reply item to be used later to
// create the reply - this allows the caller to do something after the
// reply item has been created (e.g. so the caller can use the properties
// of the reply item such as the recipients) but before the call to
// createItem has been made
export function createReplyItem(referenceItem, isReplyAll) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var bodyType, body, _a, toRecipients, ccRecipients, itemId, documentId, subject, item;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(isReplyAll && hasMoreRecipientsOnServer(referenceItem))) return [3 /*break*/, 2];
                    return [4 /*yield*/, loadAllRecipientsForItem(referenceItem)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2:
                    bodyType = getDefaultBodyType();
                    body = bodyContentType({
                        BodyType: bodyType,
                        Value: buildReplyForwardMessageBody('', bodyType),
                    });
                    _a = getToCcRecipients(referenceItem.From
                        ? referenceItem.From.Mailbox
                        : referenceItem.Sender ? referenceItem.Sender.Mailbox : null, referenceItem.ToRecipients, referenceItem.CcRecipients, referenceItem.ReplyTo, isReplyAll), toRecipients = _a[0], ccRecipients = _a[1];
                    itemId = createItemIdForRequest(referenceItem.ItemId);
                    documentId = getDocumentId(referenceItem);
                    subject = getReplyForwardSubject(referenceItem, true /*isReply*/);
                    item = isReplyAll
                        ? replyAllToItem({
                            ReferenceItemId: itemId,
                            ReferenceItemDocumentId: documentId,
                            ToRecipients: toRecipients,
                            CcRecipients: ccRecipients,
                            NewBodyContent: body,
                            Subject: subject,
                        })
                        : replyToItem({
                            ReferenceItemId: itemId,
                            ReferenceItemDocumentId: documentId,
                            ToRecipients: toRecipients,
                            NewBodyContent: body,
                            Subject: subject,
                        });
                    return [2 /*return*/, item];
            }
        });
    });
}
// create the draft reply using a reply item returned from createReplyItem()
// - returns a promise returning either the reply message or null
// - note doesn't throw if createItems throws, just returns null
export function createReplyFromReplyItem(replyItem, useGroupAction) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var timeFormat, createReplyResponse, _a, responseMessage, error_1;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    timeFormat = getUserConfiguration().UserOptions.TimeFormat;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    if (!useGroupAction) return [3 /*break*/, 3];
                    return [4 /*yield*/, createResponseFromModernGroup(replyItem, replyItem.NewBodyContent.BodyType, false /*isSend*/, timeFormat)];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, createItem(replyItem, replyItem.NewBodyContent.BodyType, false /*isSend*/, timeFormat)];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    createReplyResponse = _a;
                    responseMessage = createReplyResponse.ResponseMessages
                        .Items[0];
                    return [2 /*return*/, responseMessage.ResponseClass === 'Success' ? responseMessage.Items[0] : null];
                case 6:
                    error_1 = _b.sent();
                    return [2 /*return*/, null];
                case 7: return [2 /*return*/];
            }
        });
    });
}
export function hasMoreRecipientsOnServer(referenceItem) {
    return (referenceItem.RecipientCounts &&
        ((referenceItem.ToRecipients &&
            referenceItem.ToRecipients.length < referenceItem.RecipientCounts.ToRecipientsCount) ||
            (referenceItem.CcRecipients &&
                referenceItem.CcRecipients.length <
                    referenceItem.RecipientCounts.CcRecipientsCount)));
}
//# sourceMappingURL=createReply.js.map